<template>
  <div :style="styles.base" :class="getCss('payment-tabs-container')" @click="handleClickEvent()">
    <!--begin 商品tab展示    -->
    <div :class="getCss('payment-tabs')">
      <div :class="getCss('payment-tab')"
           :style="goodsTabStyle"
           v-for="(item,index) in goodsList" :key="index">
        <div
          :class="getCss('payment-tab-item')"
          v-if="item.isFixedGoodsNum === true"
          @click="activeTabIndex = index"
          :style="{...goodsTabItem,backgroundImage:
           `url('${index === activeTabIndex ? item.selectedImg : item.selectImg}')` }"
        >


        </div>
        <div v-if="item.isFixedGoodsNum === false"
             :class="getCss('payment-tab-item-input')"
             @click="activeTabIndex = index"
             :style="{...goodsTabItem,backgroundImage:
           `url('${index === activeTabIndex ? item.selectedImg : item.selectImg}')` }"
        >
          <input :class="getCss('payment-goods-input')"
                 placeholder="自定义数量"

                 :style="inputStyle"
                 :value="selfDefineNum"
                 @input="handleInputPrice"
                 @change="handleInputPrice"
                 type="number">
          <p :class="getCss('payment-total-price')"
             :style="inputPriceStyle"
             v-text="`${selfDefinePrice}元`">

          </p>

        </div>
      </div>
    </div>
    <!--end  商品tab展示    -->
    <div :style="styles.goodsDescStyle">
      <p :class="getCss('payment-goods-desc')" v-text="paymentGoodsDesc"></p>
    </div>
    <div :class="getCss('payment-coupon-list')" v-if="!isForbidUseCoupon">
      <p :class="getCss('payment-coupon-title')"
         :style="couponTitleStyle"
      >{{ configurationData.useCouponTitle }}</p>
      <template v-if="couponListInfo.length > 0 ">
        <div :class="getCss('coupon-item')"
             v-for="(item,index) in couponListInfo"
             :key="index"
        >
          <img :class="getCss('coupon-img')"
               :src="batchId === item.couponId  ? item.selectedIcon :item.selectIcon " alt="">
          <div :class="getCss('outside-select')"
               v-if="isOpenSelectCoupon || isAutoUseCoupon"
               :style="{ border: `0.06rem solid ${selectColorText}` }"
               @click="triggerClickSelectBatchId(item.couponId)">
            <div :class="getCss('inside-select')"
                 :style="{backgroundColor: `${selectColorText}` }"
                 v-if="batchId === item.couponId">

            </div>
          </div>
        </div>
      </template>

      <div :class="getCss('coupon-item')"
           :style="{...couponTitleStyle,fontWeight:'400'}"
           v-if="couponListInfo.length ===0 ">
        暂无优惠券
      </div>


    </div>
    <!--    触发支付按钮-->
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <!--    触发支付按钮-->


    <ceiba-payment
      :payId="configurationData.payId"
      :payInfoFlow="configurationData.payInfoFlow"
      :sellChannel="sellChannel"
      :payBusiness="configurationData.payBusiness"
      :isUseRoleLimit="configurationData.forceRole"
      :flowRootParam="goodsNumInfo"
      :spInfo="spInfo"
      :superCoupons="superCouponsInfo"
      :isBlockOrderFailAlert="!!configurationData.payFailMsg"
      @pay-success="handlePaySuccess"
      @pay-close="handlePayClose"
      @reach-limit="handleReachLimit"
      @get-pay-info="handleGetPayInfo"
      @midas-buy="handleMidasBuy"
      @query-unpaid-orders="handleQueryOrders"
      @cancel-order="handleCancelOrder"
      ref="paymentRef"
    >
    </ceiba-payment>
    <!--订单二次确认弹框-->
    <c-base-dialog
      v-model="confirmOrder"
      :option="confirmOrderDialogOption"
      @confirm="confirmOrder = false"
      @close="confirmOrder = false"
      v-transfer-dom
    >
      <template slot="body">
        <div>
          <div
            :class="getCss('msg-item')"
            v-for="(option, index) of configurationData.confirmOrderDialogContent"
            :key="index"
          >
                <span :class="getCss('msg-item-label')"
                >{{ option.label }}:</span>
            <span :class="getCss('msg-item-content')"
                  v-html="confirmOrderOption(option.content)"></span>
          </div>
        </div>
      </template>
      <template slot="fotter">
        <div>
          <button
            :style="confirmOrderButtonStyle"
            class="ceiba-base-dialog-ft-button"
            @click="payOrderViaSecondConfirm()"
          >{{ confirmOrderButtonText }}
          </button>
        </div>
      </template>
    </c-base-dialog>
    <!--ios支付引导弹框-->
    <c-base-dialog v-model="isShowIosPaymentGuide" :option="iosPaymentGuideOption"
                   @close="isShowIosPaymentGuide = false"
                   @confirm="isShowIosPaymentGuide = false"
                   v-transfer-dom>
      <template slot="body">
        <div>
          <p :class="getCss('tips')"> {{ configurationData.iosPaymentGuideText }}</p>
        </div>
      </template>
      <template slot="fotter">
        <div :style="iosPaymentGuideTipStyle">
          <div :style="iosPaymentGuideTipStyle" :class="getCss('tips-action-button')">
            <button
              v-if="copyText.length > 0"
              class="ceiba-base-dialog-ft-button"
              :style="copyButtonStyle"
              @click="copyFunc()"
            >
            </button>
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
// import { componentBaseMixin, common } from '../../../../ceiba-base-components';

import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

const iosPaymentInApp = 1; // app内触发ios引导
const iosPaymentInQQ = 2;  // QQ客户端内触发ios引导
const iosPaymentInWx = 3; // wx客户端内触发ios引导
const closeUserSelectCouponType = 1; // 关闭用户自己选券(禁止用活动外的券)
const openUserSelectCouponType = 2; // 打开用户自己选券到(禁止用活动外的券)
const forbidUserUseCouponType = 3; // 禁止使用一切优惠券
const autoUserUseCouponType = 4; // 自适应使用(可用活动内外的券)
const couponAvailableUseStatus = 1; // 券可用状态
const couponNotAvailableUseInTimeStatus = 5; // 券不可用状态 未到使用时间
const forbiddenUserPaymentWithCouponRemark = 'noCoupons'; // 米大师支付禁止支付使用优惠券标志
export default {
  name: 'CPublicPaymentWithGoodsSelect',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 's-payment-goods-select-',
      activeTabIndex: 0,
      selfDefineNum: '', // 自定义输入购买数量
      batchId: '', // 当前选中选中的优惠券
      couponList: [], // 获取到优惠券列表
      remnantPayTimes: 1, // 个人购买剩余次数为0，不可支付
      availableQuantityTimes: 1, // 系统剩余总限量，剩余总限量为0，不可支付
      confirmOrder: false, // 是否显示订单二次确认弹框
      isShowIosPaymentGuide: false, // 是否显示显示ios支付引导
    };
  },
  computed: {
    // 是否禁止用券
    isForbidUseCoupon() {
      const { couponSelectType = closeUserSelectCouponType } = this.configurationData;
      return couponSelectType === forbidUserUseCouponType;
    },
    // 是否自适应用券，可使用活动内外的优惠券
    isAutoUseCoupon() {
      const { couponSelectType = closeUserSelectCouponType } = this.configurationData;
      return couponSelectType === autoUserUseCouponType;
    },
    // 是否可用户自己选择用券
    isOpenSelectCoupon() {
      const { couponSelectType = closeUserSelectCouponType } = this.configurationData;
      return couponSelectType === openUserSelectCouponType;
    },
    sellChannel() {
      const { sellChannel = '' } = this.configurationData;
      if (this.$isInEditor) return  sellChannel;
      let { specifiedSellChannel = [] } = this.configurationData;
      console.log('parse before channel 区分销售渠道=  ', specifiedSellChannel);
      if (!(specifiedSellChannel instanceof Array)) {
        specifiedSellChannel = [];
      }
      if (specifiedSellChannel.length === 0) {
        console.warn('call getSellChannel and specifiedSellChannel is empty and access default sellChannel = ', sellChannel);
        return  sellChannel;
      }
      try {
        specifiedSellChannel = specifiedSellChannel.map((item) => {
          if (typeof item === 'string' && item.length > 0) {
            return JSON.parse(item);
          }
          return item;
        });
      } catch (e) {
        console.error(' parse specifiedSellChannel  has error and access default sellChannel = ', sellChannel);
        return  sellChannel;
      }
      const hitChannel = typeof common.tool.getRuleValue === 'function'
        ? common.tool.getRuleValue(this, specifiedSellChannel) : '';
      console.log('call getSellChannel and return hitChannel  2 = ', hitChannel);
      if  (typeof  hitChannel !== 'string' || hitChannel.length ===  0) {
        console.warn('call getSellChannel and not match and access default sellChannel = ', sellChannel);
        return sellChannel;
      }
      return hitChannel;
    },
    // 支付是否使用优惠券
    // noCoupons 表示禁止支付选用优惠券
    // “${codeId},${batchId}”  //  这个是选中一张默认优惠券
    superCouponsInfo() {
      // 禁止使用券
      if (this.isForbidUseCoupon) {
        console.warn('computer superCouponsInfo is forbidden', forbiddenUserPaymentWithCouponRemark);
        return forbiddenUserPaymentWithCouponRemark;
      }
      // 如果没有匹配到任用优惠券
      if (!this.batchId || this.couponList.length === 0) {
        // 自定使用券 可以使用活动内外
        if (this.isAutoUseCoupon) {
          console.warn('computer superCouponsInfo 如果没有匹配到任用优惠券 返回 空字符串 ', '');
          return  '';
        }
        console.log('computer superCouponsInfo res = empty 如果没有匹配到任用优惠券', forbiddenUserPaymentWithCouponRemark);
        return forbiddenUserPaymentWithCouponRemark;
      }
      if (this.couponList.length === 0) return forbiddenUserPaymentWithCouponRemark;
      const { batchId } = this;
      const item = this.couponList.find(item => item.batch_id === batchId);
      let   res = item ? `${item.code_id},${item.batch_id}` :  '';
      if (!res) {
        res = this.isAutoUseCoupon ?  '' : forbiddenUserPaymentWithCouponRemark;
      }
      console.log('computer superCouponsInfo res =', res);
      return res;
    },
    // 所有可用优惠券的列表
    spInfo() {
      if (this.superCouponsInfo === forbiddenUserPaymentWithCouponRemark) {
        console.log('computer 可用优惠券列表 empty spInfo res  =', this.superCouponsInfo);
        return '';
      }
      const spInfoText = this.couponList.map(item => `${item.code_id},${item.batch_id}`).join(';');
      console.log('computer 可用优惠券列表 not empty spInfo res  =', spInfoText);
      return spInfoText;
    },
    goodsNumInfo() {
      const configItem = this.configurationData.goodsConfigList[this.activeTabIndex] || {};
      let quantity = 0;
      const { isFixedGoodsNum, goodsNum, price } = configItem;
      if (isFixedGoodsNum === true) {
        quantity = parseInt(goodsNum / price, 10);
      }
      if (isFixedGoodsNum === false) {
        quantity = parseInt(this.selfDefineNum / price, 10);
      }
      console.log('quantity = ', quantity);
      return { quantity };
    },
    couponListInfo() {
      const { coupon, couponListIconConfig, maxUseCouponNum } = this.configurationData;
      if (!coupon) {
        return [];
      }
      const tempList = [...couponListIconConfig];
      console.log('tempList =', tempList);

      if (this.$isInEditor) {
        const res = tempList.splice(0, maxUseCouponNum);
        console.log('res =', res);
        return res;
      }
      if (this.couponList.length === 0) return [];
      const batchIds = this.couponList.map(item => item.batch_id);
      const tempArray = [];
      for (const item of tempList) {
        if (batchIds.indexOf(item.couponId) > -1) {
          tempArray.push(item);
        }
      }
      console.log('couponListInfo =', tempArray);
      return tempArray;
    },
    selectColorText() {
      const { couponStyle = {} } = this.styles;
      const { selectColor } = couponStyle;
      return selectColor || '#EB824D';
    },
    couponTitleStyle() {
      const { couponStyle = {} } = this.styles;
      const { color, fontSize, fontWeight, fontFamily } = couponStyle;
      return { color, fontSize, fontWeight, fontFamily };
    },
    paymentGoodsDesc() {
      const { goodsConfigList = [] } = this.configurationData;
      return goodsConfigList[this.activeTabIndex]?.productDesc || '';
    },
    inputStyle() {
      const { inputTabStyle = {} } = this.styles;
      const {
        inputTextColor,
        inputTextFontFamily,
        inputTextFontSize,
        inputPositionLeft,
        inputPositionTop,
        inputWidth,
        inputHeight,
        inputFontWeight = '500',
      } = inputTabStyle;
      return {
        fontWeight: inputFontWeight,
        color: inputTextColor,
        '--placeHolderColor': inputTextColor,
        '--placeHolderFontWeight': inputFontWeight,
        fontFamily: inputTextFontFamily,
        fontSize: inputTextFontSize,
        left: inputPositionLeft,
        top: inputPositionTop,
        width: inputWidth,
        height: inputHeight,
        lineHeight: inputHeight,
        border: this.$isInEditor ? '1px dashed #076DE3' : 'none',
      };
    },
    inputPriceStyle() {
      const { inputTabStyle = {} } = this.styles;
      const {
        inputTextColor,
        inputTextFontFamily,
        inputWidth,
        inputHeight,
        inputTextPositionLeft,
        inputTextPositionTop,
        textFontSize,
        textPriceColor,
        textPriceFontWeight = '500',
      } = inputTabStyle;
      return {
        color: textPriceColor || inputTextColor,
        fontWeight: textPriceFontWeight,
        fontFamily: inputTextFontFamily,
        fontSize: textFontSize,
        left: inputTextPositionLeft,
        top: inputTextPositionTop,
        width: inputWidth,
        height: inputHeight,
        lineHeight: inputHeight,
        border: this.$isInEditor ? '1px dashed #076DE3' : 'none',
      };
    },
    // 自定义输入价格
    inputPrice() {
      const configItem = this.configurationData.goodsConfigList.find(item => item.isFixedGoodsNum === false);
      const { price = 100 } = configItem;
      return price;
    },
    selfDefinePrice() {
      console.log('selfDefinePrice =', this.selfDefineNum);
      if (!this.selfDefineNum || this.selfDefineNum <= 0) return 0;
      const price = this.selfDefineNum / this.inputPrice;
      if (price > 0) {
        return parseInt(price * 100, 10) / 100;
      }
      return 0;
    },
    goodsTabStyle() {
      const { goodsTabStyles = {} } = this.styles;
      const { tabWidth, tabHeight } = goodsTabStyles;
      return {
        width: tabWidth,
        height: tabHeight,
      };
    },
    goodsTabItem() {
      const { goodsTabStyles = {} } = this.styles;
      const { tabWidth, tabHeight } = goodsTabStyles;
      return {
        backgroundSize: '100% 100%',
        width: tabWidth,
        height: tabHeight,
      };
    },
    goodsList() {
      const { goodsConfigList = [] } = this.configurationData;
      return goodsConfigList;
    },
    isMobile() {
      return common.platform.isIos || common.platform.isAndroid;
    },
    computedStyle() {
      const { rechargeButtonStyle } = this.styles;
      const {
        rechargeButtonBgImage,
        payDoneBackgroundImage,
        notAvailableQuantityBackgroundImage,
      } = this.configurationData;
      let bgImage = rechargeButtonBgImage;
      if (this.remnantPayTimes <= 0) {
        bgImage = payDoneBackgroundImage;
      } else if (this.availableQuantityTimes <= 0) {
        bgImage = notAvailableQuantityBackgroundImage;
      }

      return {
        ...rechargeButtonStyle,
        cursor: 'pointer',
        position: 'static',
        margin: '0 auto',
        display: 'block',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `
      url(${bgImage})`,
      };
    },
    // 二次确认弹框
    confirmOrderDialogOption() {
      return Object.assign({}, this.dialogConfig, {
        header: this.configurationData.confirmOrderDialogTitle || '订单确认',
        footer: false,
        height: this.deviceMode === 'pc' ? '660px' : '6.6rem',
        width: this.deviceMode === 'pc' ? '820px' : '7.2rem',
        dialogStyle: Object.assign({ color: '#000000' }, this.dialogConfig?.dialogStyle || {}),
      });
    },
    // 二次确认弹框下单样式
    confirmOrderButtonStyle() {
      if (this.dialogConfig?.confirmStyle?.backgroundImage) {
        return {
          width: '2.2rem',
          display: 'block',
          height: '0.65rem',
          backgroundImage: this.dialogConfig?.confirmStyle?.backgroundImage,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          // backgroundSize:'100% 100%',
          margin: '0 0',
        };
      }
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundColor: '#3b3a3a',
        color: '#fff',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    confirmOrderButtonText() {
      return this.dialogConfig?.confirmStyle?.backgroundImage ? '' : '确认';
    },
    isApp() {
      return this.$ast.isAPP();
    },
    //  ios 引导
    iosPaymentGuideOption() {
      return Object.assign({}, this.dialogConfig, {
        fotter: true,
        close: true,
        header: '温馨提示',
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    iosPaymentGuideTipStyle() {
      return {
        width: this?.dialogConfig?.width,
      };
    },
    // ios 复制按钮
    copyButtonStyle() {
      const { copyButtonIcon = '' } = this.configurationData;
      if (copyButtonIcon) {
        return {
          width: '2.2rem',
          display: 'block',
          height: '0.65rem',
          backgroundImage: `
      url(${copyButtonIcon})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          // backgroundSize:'100% 100%',
          margin: '0 auto',
        };
      }
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundColor: '#3b3a3a',
        color: '#fff',
        content: '复制链接',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    copyText() {
      return this.configurationData.copyIosPaymentGuideText || '';
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    // 获取
    getGoodsInfo() {
      const { goodsConfigList = [] } = this.configurationData;
      const res = goodsConfigList[this.activeTabIndex];
      if (!res) {
        console.error('支付商品信息错误，没有配置 goodsConfigList = ', res);
      }
      return res;
    },
    // 触发选中|不选中优惠券
    triggerClickSelectBatchId(batchId) {
      if (this.$isInEditor) return;
      console.log('triggerClickSelectBatchId batchId=', batchId);
      if (!batchId) {
        return false;
      }
      const couponItem = this.couponList.find(item => item.batch_id === batchId);
      if (!couponItem) {
        console.log('triggerClickSelectBatchId couponItem=', couponItem);
      }
      const isStart = this.checkCouponIsStart(couponItem);
      if (isStart) {
        this.batchId = this.batchId.length > 0 ? '' : batchId;
      } else {
        this.batchId = ''; // 没有开始的优惠券无法选中
      }
      console.log('triggerClickSelectBatchId this.batchId=', this.batchId);
    },
    // 输入点券数 处理购买上限
    handleInputPrice(e) {
      const num = parseInt(e.target.value, 10);
      const { maxGoodsNum = 0 } = this.configurationData;
      console.log('handleInputPrice num =', num, 'maxGoodsNum =', maxGoodsNum);
      if (num >= maxGoodsNum) {
        this.selfDefineNum = maxGoodsNum;
        e.target.value = maxGoodsNum;
      } else {
        this.selfDefineNum = num;
      }
      console.log('this.selfDefineNum', this.selfDefineNum);
    },
    initialize() {
      if (this.$isInEditor) return;
      common.tool.loadScript('midas-js', 'https://midas.gtimg.cn/h5pay/js/api/midas.js', () => {
      });
      this.$refs.button.setClickHandler(this.payOrder, {
        forceLogin: true,
        forceApp: this.configurationData.forceApp,
        forceRole: this.configurationData.forceRole,
      });
      if (this.configurationData.forceRole) {
        if (this.isRoleReady) {
          //  查询购买上限
          this.queryRemnantPayTimes();
          this.queryCouponList();
        } else {
          //  查询购买上限
          this.queryRemnantPayTimes();
          this.queryCouponList();
        }
      } else {
        if (this.isLogin) {
          this.queryRemnantPayTimes();
          this.queryCouponList();
        } else {
          this.$onLogined(async () => {
            this.queryRemnantPayTimes();
            this.queryCouponList();
          });
        }
      }
      ;
    },
    async beforePayOrderCheck() {
      const {
        notAvailableQuantityMsg,
        notRemnantPayTimesMsg,
      } = this.configurationData;

      // 先查询是否还有上限
      await this.queryAvailableQuantity(); // 查询剩余总限
      if (this.availableQuantityTimes <= 0) {
        this.$alert({ msg: notAvailableQuantityMsg || '已售罄' });
        return false;
      }
      await this.queryRemnantPayTimes(); // 查询剩余支付次数
      if (this.remnantPayTimes <= 0) {
        this.$alert({ msg: notRemnantPayTimesMsg || '已购买' });
        return false;
      }
      return true;
    },
    // 下单
    async payOrder() {
      if (this.checkTypeLimitPayment() === false) return false;
      // ios 是否有配置端外引导

      const isNeedIosPaymentGuide = this.handleIosPaymentGuide();
      console.log('payOrder isNeedIosPaymentGuide', isNeedIosPaymentGuide);
      if (isNeedIosPaymentGuide === false) return false;
      // 检测是否超过购买点券
      if (this.checkLimitMaxGoodsNum() === false) return false;
      // 结束是够100倍数
      if (this.checkIsMatchPriceMultiple() === false) return false;

      const { isConfirmOrder } = this.configurationData;
      if (isConfirmOrder) {
        this.confirmOrder = true;
        return;
      }
      const beforePayOrderCheck = await this.beforePayOrderCheck();
      if (!beforePayOrderCheck) {
        console.warn('beforePayOrderCheck before Check not ok ');
        return;
      }
      // 查询是否已经达到限量
      await this.toOrder();
    },
    // 通过订单确认下单
    async payOrderViaSecondConfirm() {
      const beforePayOrderCheck = await this.beforePayOrderCheck();
      if (!beforePayOrderCheck) {
        console.warn('beforePayOrderCheck before Check not ok ');
        return;
      }
      await this.toOrder();
    },
    // 支付下单 调用米大师 支付
    async toOrder() {
      if (!this.isLogin) return;
      try {
        await this.$refs.paymentRef.buy();
      } catch (e) {
        console.error('payOrder fail, err=', e);
      }
    },
    // 支付限量
    async handleReachLimit() {
      console.log('====支付限量 ====');
    },
    // 支付失败
    async handlePayClose() {
      console.log('====支付失败 ====');
    },
    // 支付成功回调
    async handlePaySuccess(midasInfo) {
      console.log('handlePaySuccess midasInfo', midasInfo);
      await this.refreshQua(); // 刷新礼包
      await this.queryAvailableQuantity();// 查询剩余总限量
      await this.queryRemnantPayTimes(); // 重新查询支付次数
      const { paySuccessMsg, paySuccessFlowId } = this.configurationData;
      // 支付成功自定义提示
      if (paySuccessMsg) {
        const partitionName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
        const roleName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
        this.$alert({ msg: paySuccessMsg.replace('{{partition}}', partitionName).replace('{{role}}', roleName) });
      }
      if (paySuccessFlowId > 0) {
        await this.paySuccessCallback();
      }
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_callback',
        eventData: {
          pay_id: midasInfo.pay_id,
          order_id: midasInfo.order_id,
          status: '1',
        },
      });
      // 支付成功
      this.refreshContainerStatus();
    },
    //  存在多个预约地方的时候  同步
    refreshContainerStatus() {
      this.$eventBus.$emit('ceiba:custom:events:refresh:container:status', null);
    },
    // 执行下单逻辑
    handleGetPayInfo({ payId, response }) {
      console.log('handleGetPayInfo params', { payId, response });
      const { payFailMsg } = this.configurationData;
      if (payFailMsg) {
        const partitionName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
        this.$alert({ msg: payFailMsg.replace('{{partition}}', partitionName) });
      }
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_makeorder',
        eventData: {
          pay_id: payId,
          status: response.ret === 0 && response.data.ret === 0 ? '1' : '0',
        },
      });
    },
    // 查询未支付的订单
    handleQueryOrders({ response }) {
      console.log('handleQueryOrders params', { response });
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_queryorders',
        eventData: {
          status: response.ret === 0 ? '1' : '0',
        },
      });
    },
    // 取消订单
    handleCancelOrder({ orderId, response }) {
      console.log('handleCancelOrder params', { orderId, response });
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_cancelorder',
        eventData: {
          order_id: orderId,
          status: response.ret === 0 ? '1' : '0',
        },
      });
    },
    // 米大师支付 (用户拉去支付)
    handleMidasBuy(midasInfo) {
      console.log('handleMidasBuy midasInfo', midasInfo);
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay',
        eventData: {
          pay_id: midasInfo.pay_id,
          order_id: midasInfo.order_id,
          amount: midasInfo.amount,
        },
      });
    },
    // 成功回调流程
    async paySuccessCallback() {
      const { paySuccessFlowId } = this.configurationData;
      if (paySuccessFlowId <= 0) return;
      const response = await this.flowRequest({
        flowId: paySuccessFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet === 0) {
        // await this.queryRemnantPayTimes();
      } else {
        return this.$alert({ msg: resMsg || '支付失败' });
      }
    },
    // 查询剩余支付次数|个限量  没有次数就置灰 条件机输出
    async queryRemnantPayTimes() {
      const { queryRemnantPayTimesFlowId = 0 } = this.configurationData;
      if (queryRemnantPayTimesFlowId <= 0) return;
      const params = {
        flowId: queryRemnantPayTimesFlowId,
        params: {
          role: this.roleInfo,
        },
      };
      const response = await this.flowRequest(params);
      console.log('查询剩余支付次数 queryRemnantPayTimes queryRemnantPayTimesFlowId = ', queryRemnantPayTimesFlowId);
      console.log('查询剩余支付次数 queryRemnantPayTimes response ', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { value = 0, ret: resRet } = data;
      if (resRet === 0) {
        this.remnantPayTimes = value;
      }
    },
    // 查询剩余总限量  没有次数就置灰 条件机输出
    async queryAvailableQuantity() {
      const { queryAvailableQuantityFlowId = 0 } = this.configurationData;
      if (!queryAvailableQuantityFlowId || queryAvailableQuantityFlowId <= 0) return;
      const params = {
        flowId: queryAvailableQuantityFlowId,
        params: {
          role: this.roleInfo,
        },
      };
      const response = await this.flowRequest(params);
      console.log('查询剩余总限量 queryAvailableQuantity queryAvailableQuantityFlowId = ', queryAvailableQuantityFlowId);
      console.log('查询剩余总限量 queryAvailableQuantity response ', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { value = 0, ret: resRet } = data;
      if (resRet === 0) {
        this.availableQuantityTimes = value;
      }
    },
    // 订单确认弹框-确认项
    confirmOrderOption(option) {
      const uinTypeName = common.platform.isWX ? '【微信账户】' : '【QQ账户】';
      switch (option) {
        case '{{role}}':
          return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
          break;
        case '{{partition}}':
          return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
          break;
        case '{{uin}}':
          return this.isLogin ? ` < span class= "csu-public-pay-button-msg-item-nick-name" >${this.userInfo.nickName} < /span>
        ${uinTypeName}` : `${uinTypeName}`;
          break;
        default:
          return option;
      }
    },
    copyFunc() {
      const { copyIosPaymentGuideText = '' } = this.configurationData;
      const text = copyIosPaymentGuideText || window.location.href;
      if (typeof text === 'string' && text.length > 0) {
        const textarea = document.createElement('textarea');
        document.body.appendChild(textarea);
        textarea.style.position = 'fixed';
        textarea.style.clip = 'rect(0 0 0 0)';
        textarea.style.top = '10px';
        textarea.value = text;
        textarea.select();
        document.execCommand('copy', true);
        document.body.removeChild(textarea);
        this.isShowIosPaymentGuide = false;
        this.$toast('复制成功');
      }
    },
    // 判断限制为是否确定购买100倍数
    checkIsMatchPriceMultiple() {
      const goodsConfig = this.getGoodsInfo();
      const { isFixedGoodsNum } = goodsConfig;
      if (isFixedGoodsNum !== false) return true;
      const { limitPriceMultiple = 0, limitPriceMultipleMsg } = this.configurationData;
      if (this.selfDefineNum <= 0) {
        this.$alert({ msg: limitPriceMultipleMsg });
        return false;
      }

      if (limitPriceMultiple > 0 && this.selfDefineNum % limitPriceMultiple !== 0) {
        this.$alert({ msg: limitPriceMultipleMsg });
        return false;
      }
      return true;
    },
    isWxUserType() {
      if (common.platform.isWX) return true;
      if (this.isApp && common.tool.getCookie('acctype') === 'wx') {
        return true;
      }
      return false;
    },
    // 判断用户类型
    checkTypeLimitPayment() {
      const { typeLimitPaymentConfig = [] } = this.configurationData;
      if (!typeLimitPaymentConfig || typeLimitPaymentConfig.length === 0) return true;
      for (const { ruleType: funcName, limitMsg } of typeLimitPaymentConfig) {
        if (typeof this[funcName] === 'function' && this[funcName]() === true) {
          this.$alert({ msg: limitMsg || '条件不满足' });
          return false;
        }
      }
      return true;
    },
    //  确定购买超过上限
    checkLimitMaxGoodsNum() {
      const goodsConfig = this.getGoodsInfo();
      // 判断一次最大的购买次数
      const { maxGoodsNum, limitMaxGoodsNumMsg } = this.configurationData;
      const { goodsNum, isFixedGoodsNum } = goodsConfig;

      if (isFixedGoodsNum === true && maxGoodsNum < goodsNum) {
        this.$alert({ msg: limitMaxGoodsNumMsg });
        return false;
      }

      if (isFixedGoodsNum === false && maxGoodsNum < this.selfDefineNum) {
        this.$alert({ msg: limitMaxGoodsNumMsg });
        return false;
      }
      return true;
    },
    handleIosPaymentGuide() {
      console.log('handleIosPaymentGuide', common.platform.isIos);
      if (!common.platform.isIos) {
        return true;
      }
      const {
        iosPaymentGuideText,
        iosPaymentGuideTriggerPlace = [iosPaymentInApp, iosPaymentInQQ, iosPaymentInWx],
      } = this.configurationData;
      // 没有限制
      if (!iosPaymentGuideText) {
        return true;
      }
      // 没有限制
      if (iosPaymentGuideTriggerPlace.length === 0 || !iosPaymentGuideTriggerPlace) {
        return true;
      }
      if (iosPaymentGuideTriggerPlace.indexOf(iosPaymentInApp) > -1 && this.isApp) {
        this.isShowIosPaymentGuide = true;
        return false;
      }
      if (iosPaymentGuideTriggerPlace.indexOf(iosPaymentInQQ) > -1 && common.platform.isQQ) {
        this.isShowIosPaymentGuide = true;
        return false;
      }
      if (iosPaymentGuideTriggerPlace.indexOf(iosPaymentInWx) > -1 && common.platform.isWX) {
        this.isShowIosPaymentGuide = true;
        return false;
      }
      return true;
    },
    // 查询优惠券列表并且过滤出优惠券
    async queryCouponList() {
      const { queryCouponListFlowId = 0, maxUseCouponNum, coupon } = this.configurationData;
      if (queryCouponListFlowId <= 0 || !queryCouponListFlowId) {
        return false;
      }
      if (!coupon) return;
      const couponList = coupon.split(',').filter(item => !!item);
      console.log('couponList setting  in configurationData= ', couponList);
      if (couponList.length === 0) {
        return false;
      }

      if (!queryCouponListFlowId || queryCouponListFlowId <= 0) return;
      const params = {
        flowId: queryCouponListFlowId,
        params: {
          role: this.roleInfo,
        },
      };
      const response = await this.flowRequest(params);
      console.log('queryCouponList response:', response);
      console.log('queryCouponList check:', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { data: dataRes, ret: resRet } = data;
      let couponFilterList = [];
      if (resRet === 0 && dataRes && dataRes.length > 0) {
        for (const item of dataRes) {
          if (couponList.indexOf(item.batch_id) > -1) {
            couponFilterList.push(item);
          }
        }
      }
      console.log(' queryCouponList couponList filter   in couponFilterList= ', couponFilterList);
      couponFilterList = this.sortCouponList(couponFilterList);
      console.log(' queryCouponList couponList sort  in couponFilterList= ', couponFilterList);

      if (couponFilterList.length > maxUseCouponNum) {
        couponFilterList = couponFilterList.splice(0, maxUseCouponNum);
      }
      this.couponList = couponFilterList;
      if (this.couponList.length > 0) {
        this.batchId = this.checkCouponIsStart(this.couponList[0]) ? this.couponList[0]?.batch_id : '';
      } else {
        this.batchId = '';
      }
      console.log(' queryCouponList this.batchId = ', this.batchId);
      console.log('queryCouponList final couponList', this.couponList);
    },
    sortCouponList(couponFilterList) {
      if (couponFilterList.length <= 1) {
        return couponFilterList;
      }
      couponFilterList.sort((a, b) => {
        if (a.amt !== b.amt) {
          return b.amt - a.amt;
        }
        return a.start_time - b.start_time;
      });
      return couponFilterList;
    },
    // 测试优惠券是否可以使用
    // status  = 1  && sub_status === undefined   可使用
    // sub_status !== undefined && sub_status === 5  &&   status  = 1  不可用
    checkCouponIsStart(couponItem) {
      const { status = 1, sub_status: subStatus } = couponItem;
      console.log('checkCouponIsStart status = ', status, 'sub_status = ', subStatus);
      if (status === couponAvailableUseStatus && typeof subStatus === 'undefined') {
        console.log('checkCouponIsStart res = ', '优惠券可用', couponItem);
        return true;
      }
      if (status === couponAvailableUseStatus && subStatus === couponNotAvailableUseInTimeStatus) {
        console.log('checkCouponIsStart res = ', '优惠券不可用', couponItem);
        return false;
      }
      console.log('checkCouponIsStart res =  ', '不匹配任何状态', couponItem);
      return false;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
